import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { error } = theme.palette;

  return {
    fieldErrorMessage: {
      display: "flex",
      alignItems: "center",
      color: error.main,
      fontSize: 11
    }
  };
});
